import { Col, Container, Row } from "reactstrap";
import Chip from "src/components/Common/UI/Chips/Chip";
import ParametersHeader from "../ParametersHeaders";
import PendingStatus from "./PendingStatus/PendingStatus";
import Providers from "./Providers/Providers";


const Others = () =>{

    const chipHeaders = ["Κατηγορίες Εκκρεμοτήτων", "Παροχείς"];
    const chipItems: React.ReactNode[] = [
      <PendingStatus/>,
      <Providers />,
    ];
  
    return (
      <div className="page-content">
        <ParametersHeader />
  
        <Container fluid>
          <Row>
            <Col xs={12}>
              {<Chip
                tabNavHeaderItems={chipHeaders}
                tabContentItems={chipItems}
                hasStatusCircle={false}
              />}
            </Col>
          </Row>
        </Container>
  
  
      </div>
    );
}

export default Others